import { useNotificationStore } from '../../store/NotificationStore';
import styles from './NotificationWrapper.module.scss';
import Notification from './Notification';
import { useTelegram } from '@/app/providers/TelegramProvider';

export default function NotificationWrapper() {
  const showNotification = useNotificationStore(
    (state) => state.showNotification,
  );
  const { systemInsets, contentInsets } = useTelegram();

  const topOffset = systemInsets.top + contentInsets.top + 16;

  return (
    <div className={styles.container} style={{ top: `${topOffset}px` }}>
      <div
        className={`${styles.wrapper} ${
          showNotification ? styles.show : styles.hide
        }`}
      >
        <Notification />
      </div>
    </div>
  );
}
